export function setDetails(state, { payload }) {
	state.details = payload;
}
